import React from 'react';
import { Button } from 'app/components';
import { useNavigate } from 'react-router-dom';
import { useSelector } from 'react-redux';
import useLoginModal from '../../login/useLoginModal';

const Layout = () => {
  const navigate = useNavigate();
  const loginModal = useLoginModal();
  const { userData } = useSelector((state) => state.app);

  const handleClick = () => {
    const phoneNumber = '9025082101';
    const message = "I'm very interested in your ticketing platform and would love to discuss it further.";
    const desktopUrl = `https://web.whatsapp.com/send?phone=${phoneNumber}&text=${encodeURIComponent(message)}`;
    const mobileUrl = `https://api.whatsapp.com/send?phone=${phoneNumber}&text=${encodeURIComponent(message)}`;
    const isMobile = window.innerWidth < 650; // For mobile, width less than 1024px

    const url = '/event/create';
    if (!userData?.email) {
          loginModal.onOpen();
      loginModal.callback.current = () => navigate(url);
    } else {
      navigate(url);
    }
  };

  const onCreateEventClick = () => {
    if (!userData?.email) {
      loginModal.onOpen();  
      loginModal.callback.current = () => navigate('/event/create');
    } else {
      navigate('/event/create');
    }
  };
  
  return (
    <section className="flex flex-col items-center bg-white p-5 md:py-16 md:max-w-5xl m-auto gap-10 ">
      <h1 className=" heading-36 md:text-6xl font-bold text-center py-10 w-full">
        We understand your needs better than everyone else
      </h1>
      <div className="flex flex-col gap-8 md:max-w-5xl">
        <div className='flex flex-col md:flex-row gap-4'> 
                  {/* Fastest Event Payout */}
        <div className="bg-gradient-to-b from-[#fff2f2] to-[#fcdfe9] rounded-3xl border border-primary  p-10 gap-4 md:gap-10 flex flex-col md:flex-row items-center justify-between text-center max-full md:max-w-[670px] max-h-[375px] shadow-lg">
        <img
            src="assets/images/mailcheck.png" // Replace with actual image
            alt="Event Payout"
            className=" w-[150px] h-[180px] md:hidden"
          /> 
          <div className='flex flex-col items-start gap-4 w-full md:w-1/2 justify-start text-left '> <div className="text-xl md:text-3xl font-bold">Fastest event payout</div>
          <p className="text-16">Stay ahead of the game with fresh tips every week.</p> </div>
         
          <img
            src="assets/images/mailcheck.png" // Replace with actual image
            alt="Event Payout"
            className=" w-[150px] h-[180px] hidden md:block"
          />
        </div>

        {/* Ticket Scanning */}
        <div className="bg-[#F32455] rounded-3xl p-10 pb-0 flex flex-col items-center text-center gap-6 shadow-lg max-h-[375px] max-w-full md:max-w-[330px]">
          <div className="text-xl md:text-3xl font-bold text-white text-left">Ticket scanning made easy</div>
          <img
            src="assets/images/framer1.png"
            alt="Ticket Scanning"
            className="w-[180px]  h-[234px] "
          />
        </div>
        </div>
        <div className='flex flex-col md:flex-row gap-4 '>
        {/* Event Reports */}
        <div className="bg-[#F8F8F8] p-10 pb-0 flex flex-col items-center text-center w-full md:w-[330px] rounded-3xl border border-[#B8B8B8] shadow-lg max-h-[376px]">
          <div className="text-xl md:text-3xl font-bold ">Event Reports</div>
          <img
            src="assets/images/framer3.png" // Replace with actual image
            alt="Event Reports"
            className="w-[270px] h-[300px] md:w-auto md:h-[280px]"
          />
        </div>

        {/* Real-time Analytics */}
        <div className="bg-[#FFF5DB] p-10 pt-[50px] pb-0 flex flex-col items-end text-center rounded-3xl border border-[#DED300] shadow-lg max-w-full md:max-w-[670px] max-h-[376px] justify-between gap-4 md:gap-0">
          <div className='flex flex-col md:flex-row justify-between items-center'>
          <div className="text-3xl font-bold flex items-start text-left w-full md:w-1/3 gap-3 md:gap-0">Real-time Detailed Analytics</div>
          <div className="text-16 w-full md:w-[45%] text-left ">Get real-time analytics at your fingertips. Manage your attendees effortlessly.</div>
          </div>
         
          <img
            src="assets/images/framer2.png" // Replace with actual image
            alt="Analytics"
            className="w-[330px] h-[190px]"
          />
        </div>
        </div>
    <div className='flex flex-col md:flex-row justify-evenly gap-4'>
        {/* 75% Savings */}
        <div className="bg-[#DFEFD7] text-[#68944E] rounded-3xl p-10 flex flex-col text-center border border-[#68944E] w-full md:w-[280px] h-[180px] md:h-[300px] font-satoshi items-start justify-center shadow-lg">
          <div className="text-[100px] font-semibold tracking-tight h-[120px]">75<span className='text-4xl'>%</span></div>
          <div className="text-xl font-general-sans">more savings in fees</div>
        </div>

        {/* Multiple Export Options */}
        <div className="bg-grey-5  rounded-3xl p-10 flex flex-col items-start text-center justify-center border border-grey-30 w-full md:w-[430px] shadow-lg ">
          <div className='text-2xl font-medium gap-2.5 items-start justify-start text-left'> 
          <div>Multiple export options</div>
          <div>On demand payout </div>
          <div>24*7 Support </div>
          </div>
          <p className="text-sm">and many more…</p>
        </div>

        {/* Faster Event Launch */}
        <div className="bg-[#FAE4D0] rounded-3xl p-10 flex flex-col  text-center w-full md:w-[280px] h-[180px] md:h-[300px] font-satoshi items-start justify-center text-[#C28951] border-[#C28951] border shadow-lg " >
        <div className="text-[100px] font-semibold tracking-tight h-[120px]">7x</div>
        <div className="text-xl font-general-sans">Faster event launch</div>
        </div>
      </div>
      </div>
      
        {/* Button */}
        <div className='hero-button'>
        {/* <Button type="primary-black" rounded="true"
        onClick={onCreateEventClick}>
         <div className='label-16'> List an event</div>
    
        </Button> */}
        <Button type="primary-black" rounded="true"     
        onClick={handleClick} 
        > 
         <div className='label-16'>List your event</div>
    
        </Button>
        </div>
    </section>
  );
};

export default Layout;
